import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TextDefaults = {
  fontFamily: string
  fontSize: number
  fontColor: string
}

type TextDefaultsStore = {
  defaults: TextDefaults
  setDefaults: (defaults: Partial<TextDefaults>) => void
  resetDefaults: () => void
}

const initialDefaults: TextDefaults = {
  fontFamily: 'Arial',
  fontSize: 16,
  fontColor: '#000000',
}

export const useTextDefaultsStore = create<TextDefaultsStore>()(
  persist(
    (set) => ({
      defaults: initialDefaults,
      setDefaults: (newDefaults) =>
        set((state) => ({
          defaults: { ...state.defaults, ...newDefaults },
        })),
      resetDefaults: () =>
        set(() => ({
          defaults: initialDefaults,
        })),
    }),
    {
      name: 'text-defaults-storage',
    },
  ),
)
